import PatientObjectBaseProvider from "./patientObjectBaseProvider";

export default class PatientOverviewFormsProvider extends PatientObjectBaseProvider {
	constructor($http, patientProvider, storage, eventBus) {
		super("citizenOverviewForms", $http, patientProvider, storage, eventBus);
	}
}
